import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles/style.css'
import { AppProvider } from './pages/context'

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
